import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApi } from '../../api/api-context';
export const useUpdateUserSimpleFinApi = (mutationConfig) => {
    const api = useApi();
    const queryClient = useQueryClient();
    const { onSuccess, onError, ...restConfig } = mutationConfig || {};
    const updateUserSimpleFinApi = async (data) => {
        const response = await api.post('/user/simple-fin', data);
        return response.data;
    };
    return useMutation({
        onSuccess: (...args) => {
            queryClient.invalidateQueries({ queryKey: ['user'] });
            queryClient.invalidateQueries({ queryKey: ['simple-fin-accounts'] });
            onSuccess?.(...args);
        },
        onError,
        ...restConfig,
        mutationFn: updateUserSimpleFinApi,
    });
};
